var React = require('react');

function Likes (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","style":{"stroke":"#407BB5","strokeMiterlimit":"10","strokeWidth":"2px"},"d":"M9.27,21A6.64,6.64,0,0,0,12,21.5,6.67,6.67,0,0,0,14.77,21a12.38,12.38,0,0,0,5.58-4.2c3.47-4.52,3.54-10.35.18-13C18.24,2,15,2.15,12,3.84,9,2.15,5.76,2,3.47,3.79c-3.36,2.63-3.29,8.43.18,13A12.3,12.3,0,0,0,9.27,21Z"}));
}

Likes.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Likes;

Likes.default = Likes;
